import { render } from "./CouponDetailIndex.vue?vue&type=template&id=629bf337"
import script from "./CouponDetailIndex.vue?vue&type=script&lang=js"
export * from "./CouponDetailIndex.vue?vue&type=script&lang=js"
script.render = render

export default script